<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
    <v-row  >
      <v-col md="12" lg="12" cols="12">
         <div>
      <v-breadcrumbs :items="dbreads" large></v-breadcrumbs>
    </div>
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Codigo se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Codigo se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Codigo se edito con éxito.
       </v-alert>
        <v-data-table
      :headers="headers"
      :items="Codigos"
      sort-by="Codigo"
      sort-desc
      class="elevation-1"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title>Codigos</v-toolbar-title>
          <v-progress-circular
        indeterminate
        v-if="progr == true"
        color="primary"
      ></v-progress-circular>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Código</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.publicKey" :counter="250" label="Nombre"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" :disabled="sirve" text @click="save">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogdelete" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Desea eliminar esta Codigo?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          small
          color="error"
          @click="deleteItem(item)"
        >
          fas fa-minus-circle
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="dameCodigos">Cargar de Nuevo</v-btn>
      </template>
    </v-data-table>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import moment from "moment";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Codigo Puerta | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      negocio: {},
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Codigos',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      token:'',
      dialog: false,
      abreviado:'NN',
        sirve:true,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      Codigos: [],
      search: '',
      editedIndex: -1,
      editedItem: {
      id: 0,
          publicKey: '',
        negocio: {},
        activo: true
    },
    defaultItem: {
      id: 0,
        publicKey: '',
      negocio: {}
    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Codigo', align: 'left',  value: 'publicKey'},
        { text: 'Negocio', value: 'negocio.negocio' },
      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
        this.dbreads[0].text = this.negocio.negocioNombre
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.dameCodigos();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })

    }else{
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

      this.dameCodigos();
    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
      this.dbreads[0].text = this.negocio.negocioNombre
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.dameCodigos();
    },
  },
  methods : {
    dameCodigos(){
      this.progr = true;
        axios
        .get('negocios/codigopuerta/' + this.idnegocio ,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Codigos = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        });
    },
    editItem (item) {
      this.editedIndex = this.Codigos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.Codigos.indexOf(item);
      this.dialogdelete = true;
    },
    borralo (){
      let md555 = this.Codigos[this.editedIndex].id;
      axios
      .delete('Codigos/negocio/'+md555,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.Codigos = response.data;
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("YYYY-MM-DD");
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.Codigos[this.editedIndex], this.editedItem);
        this.editedItem.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.negocio.cliente.createdAt))

        var bodyFormData2 = new FormData();
        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
      .post('negocios/codigopuerta/grabar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
                this.dameCodigos();
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      } else {
        var bodyFormData = new FormData();

        this.editedItem.negocio = this.negocio;
        this.editedItem.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.negocio.cliente.createdAt))

        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('negocios/codigopuerta/grabar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                this.Codigos = response.data;
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Código' : 'Editar Código'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
